<template>
  <div class="shareList">
     <Header title="分享记录" :show-back="true" />
     <van-list class="list">
        <dl class="list-title" >
          <dd  class="time">时间</dd>
          <dd>天数</dd>
          <dd>奖励金额</dd>
          <dd class="status">状态</dd>
        </dl>
        <dl  class="list-content" v-for="(item,index) in list" :key="index"> 
          <dd class="time">{{formatDate(item.time_int)}}</dd>
          <dd>第{{item.day_num}}天</dd>
          <dd class="num">{{item.num}}{{item.coin.toLocaleUpperCase()}}</dd>
          <dd class="status">{{getStatus(item.status)}}</dd>
        </dl>
        
     </van-list>
  </div>
 
</template>

<script>
import Header from "../../components/header";
export default {
  components: {
    Header
  },
  data() {
    return {
      list:[],
      isFinished:false,
      total:0,
      pageNo:0,
      loading:false
    };
  },
  created(){
    this.getData()
  },
  methods:{
    getData(page=1){
      this.ajax.post('appapi/User/picSignList',{page}).then((res)=>{
        if(res.data.code===1){
          let data = res.data.data
          this.list = data.data
          this.total = data.total
          this.pageNo= parseInt(this.current_page)
          this.loading = false
          if(this.list.length>data.total){
            this.isFinished=true
          }
        }
      })
    },
    getStatus(status){
      const statusMap={
        2:'等待审核',
        1:'审核通过',
        3:'拒绝'
      }
      return statusMap[status]

    },
    formatDate(time){
      return this.utils.formatDate(time,'yyyy-MM-dd HH:mm')
    }
  }
};
</script>

<style lang="scss">
.shareList{
  background:#fff;
  .list{
    padding:0 30px;
   
    &-title{
      @include flex($main:space-between);
      font-size: 28px;
      color:#999;
      padding:30px 20px 30px 0;
      dd{
         flex:1;
         &:last-child{
           text-align: right;
         }
      }
    }
    &-content{
      @include flex($cross:center,$main:space-between);
      padding:20px 0;
      font-size:22px;
      color:#747F9D;
      padding-right:20px;
      position: relative;
      dd{
        flex:1;
        &:last-child{
           text-align: right;
         }
      }
      .status,.num{
          color:#10914A;
      }
      .verify{
          color:#D73939;
      }
      &:before{
        border-top:1Px solid #F5F5F5;
        width:100%;
        box-sizing: border-box;
        content:'';
        position: absolute;
        top:0;
        left:0;
      }
    }
    .time{
      flex:1.8;
    }
  }
}
</style>